module.exports = __webpack_public_path__ + "static/media/torre-ambient.cbfb7113.jpg";